<template>

    <LoadingSpinner v-if="!tagsLoaded && topicCardList.length > 0 " />
    <div v-if="selectionMode && !onlySufs">
        <div class="head" >
            {{tx.ThemencardsTitle}}
        </div>
    </div>

        <div v-if="!selectionMode" class="head">
            {{tx.ThemenBoxesTitle}}
        </div>

    <!--<div class="nalserooterParagraph" v-if="selectionMode && !onlySufs">


        <div class="subHeadDes">
            {{tx.ThemeTypesCards}}
        </div>
        <div class="subhead">
            {{tx.ThemeTypesDesCards}}
        </div>
        <div class="paragraph">
            <table v-if="pgId!=3">
                <tr>
                    <td class="iconTable">
                        <i class="fa-light fa-chart-network"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            {{tx.TrendCards}}
                        </div>
                        <div class="tableTextWlc">
                            {{tx.TrendDesCards}}
                        </div>
                    </td>
                    <td class="iconTable">
                        <i class="fal fa-thumbtack"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            {{tx.SignalCards}}
                        </div>
                        <div class="tableTextWlc">
                            {{tx.SignalDesCards}}
                        </div>
                    </td>

                </tr>
                <tr>
                    <td class="iconTable">
                        <i class="fal fa-lightbulb-on"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            {{tx.IdeaCards}}
                        </div>
                        <div class="tableTextWlc">
                            {{tx.IdeaDesCards}}
                        </div>
                    </td>
                    <td class="iconTable">
                        <i class="fal fa-low-vision"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            White Spot
                        </div>
                        <div class="tableTextWlc">
                            {{tx.WSDesCards}}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="iconTable">
                        <i class="fal fa-lock"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            Givens
                        </div>
                        <div class="tableTextWlc">
                            {{tx.GivenDesCards}}
                        </div>
                    </td>

                </tr>
            </table>

            <table v-if="pgId==3">
                <tr>
                    <td class="iconTable">
                        <i class="fa-light fa-paperclip"></i>
                    </td>
                    <td>
                        <div class="tableIconTextTitle">
                            Cluster
                        </div>
                        <div class="tableTextWlc">
                            {{tx.ClusterTypeDesCards}}
                        </div>
                    </td>
                </tr>
            </table>

        </div>
    </div>
    <div v-if="selectionMode && !onlySufs">
        <div class="subHeadDes">
            {{tx.SteepFactors}}
        </div>
        <div class="subhead">
            {{tx.SteepFactorsDes}}
        </div>

    </div>-->

    <div class="footerParagraph" v-if="selectionMode && !onlySufs">

        <div class="subHeadDes">
            {{tx.SuchfeldTitleCards}}

        </div>
        <!--<div class="head" v-if="pgId==3">
            Themencluster
        </div>-->
        <div class="subhead">
            {{tx.SuchfelderDesCards}}
        </div>
      
    </div>
    <DxButton class="backBtn" @click="showStartPage" v-if="onlySufs  && !selectionMode"><i class="fa fa-arrow-circle-left"></i> Zurück zur Startseite</DxButton>
    <div v-if="!isLoading">
        <VueTagCloud :options="cloudOptions" @tagClicked="tagClicked"
                     v-bind:data="wordSource" v-if="!selectionMode"></VueTagCloud>
      
        <div class="vdSuchfelder" v-if="(selectionMode && sufId!= -1) || dashboard">
            <SuchfeldSelection v-model="rouId" @selected="selectSuchfeld"></SuchfeldSelection>
        </div>
        <div class="vdCardView" v-if="!selectionMode">

            <div class="vdSuchfeld">
                {{tx.Searchfield}}
                {{suchfeldName}}
            </div>


            <div class="vdFilterBox">
                <div class="vdFilterLeft">
                    <div class="vdFilterCell">
                        <DxButton :text="btn.ChooseSuchfeldBtnCards" @click="showSuchfeldSelection"></DxButton>
                    </div>
                    <div class="vdFilterCell">
                        <DxRadioGroup :data-source="topicTypes"
                                      value-expr="TtyId"
                                      layout="horizontal"
                                      display-expr="TtyName"
                                      v-model:value="currentTtyId"
                                      item-template="ttyTemplate">
                            <template #ttyTemplate="{ data }">

                                <i v-if="data.TtyIcon" :class="data.TtyIcon + ' vdIcon'">

                                    <span class="tooltiptext">
                                        {{data.Description}}
                                    </span>
                                </i>
                                <div class="vdTtyName">
                                    {{data.TtyName}} ({{data.Count}})
                                </div>
                            </template>
                        </DxRadioGroup>
                    </div>
                </div>
                <div class="vdFilterRight">
                    <div class="vdFilterBox" v-if="tag > ''">
                        <div class="vdFilterLabel">Tag:</div>
                        <div class="vdFilterControls vdIconTag">
                            <!--<DxTextBox :value="tag" :disabled="true" />-->
                            <DxButton icon="fas fa-circle-xmark" :text="tag" @click="resetSearch"></DxButton>
                            <span class="tooltiptext">
                                {{btn.FilterHintCards}}
                            </span>
                        </div>
                    </div>
                    <div class="vdFilterBox">
                        <div class="vdFilterLabel">{{tx.SearchTextTitle}}</div>
                        <div class="vdFilterControls">
                            <DxTextBox v-model:value="searchText" :showClearButton="true" @enterKey="searchClick" @value-changed="searchClick" />
                            <DxButton icon="fas fa-search" @click="searchClick"></DxButton>
                        </div>
                    </div>
                    <div class="vdFilterBox">
                        <div class="vdFilterControls">
                            <DxSelectBox :data-source="sortList"
                                         :show-clear-button="false"
                                         display-expr="SortName"
                                         value-expr="SortId"
                                         v-model:value="selectedSortId">

                            </DxSelectBox>
                            <div class="vdDice">

                                <i class="fas fa-dice-five" v-on:click="doRandomSort" id="dice" @mouseenter="toggleDefault"
                                   @mouseleave="toggleDefault">

                                </i>
                                <DxTooltip v-model:visible="defaultVisible"
                                           :close-on-outside-click="false"
                                           target="#dice">
                                    {{btn.DiceHintCards}}
                                </DxTooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vdInnerBox">
                <div v-for="topic in topicCardList" :key="topic.TopicId" class="vdContents">
                    <div class="vdArticel" v-on:click="openDetail(topic.TopicId)">
                        <div class="vdBody">
                            <div class="vdTitle">
                                {{topic.Title}}
                            </div>
                            <div class="tcvImage">
                                <img v-lazy="topic.Link" class="lazy" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!topicCardList || topicCardList.length ==0" class="vdEmpty">
                {{tx.NoResultCards}}
            </div>
        </div>
    </div>


    <!--<div class="footerParagraph" v-if="selectionMode && !onlySufs">
        <div class="divÜbersicht">
            <div>
                {{tx.ToThemenViewCards}}
            </div>
            <DxButton class="tsBtnÜbersicht" @click="openTopicKarten()">
                {{btn.ToThemeBtnCards}}
                <i class="fal fa-traffic-light-go"></i>
            </DxButton>

        </div>
        <div class="subHeadDes">
            {{tx.SuggestHitTitle}}
        </div>
        <div class="subhead">
            {{tx.SuggestHitCaption}}
        </div>

        <DxButton class="tsAddNew" @click="addNewTopic()">
            {{btn.SuggestNewHitBtnCards}}
        </DxButton>
    </div>-->
</template>
<script>
    import VueTagCloud from "../components/VueTagCloud"
    import { DxRadioGroup } from 'devextreme-vue/radio-group'
    import DxSelectBox from 'devextreme-vue/select-box'
    import DxButton from 'devextreme-vue/button'
    import DxTextBox from 'devextreme-vue/text-box'
    import SuchfeldSelection from './widgets/SuchfeldSelection'
    import { nextTick } from 'vue'
    import { htmlToText } from 'html-to-text'
    import { DxTooltip } from 'devextreme-vue/tooltip';
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import $ from 'jquery';
    //import { Store } from 'vuex'
    //import createPersistedState from 'vuex-persistedstate'
    //import * as Cookies from 'js-cookie'

    //const store = new Store({

    //    plugins: [
    //        createPersistedState({
    //            getState: (key) => Cookies.getJSON(key),
    //            setState: (key, state) => Cookies.set(key, state, { expires: 3, secure: true })
    //        })
    //    ]
    //})
    export default {
        name: 'TopicCardView',
        components: {
            DxRadioGroup,
            DxSelectBox,
            DxButton,
            DxTextBox,
            SuchfeldSelection,
            VueTagCloud,
            DxTooltip,
            LoadingSpinner
        },
        data() {
            return {
                defaultVisible: false,
                fullPage: true,
                tagsLoaded: false,
                cloudOptions: { valueExpr: 'Salience', nameExpr: 'Name', width: 'auto' },
                searchText: "",
                searchedText: "",
                tag: "",
                searchedTag: "",
                currentTtyId: 0,
                selectedSortId: 1,
                tx: {
                    ThemencardsTitle: this.$LanguageProvider.GetResource("ThemencardsTitle", "Caption", "Themenkarten"),
                    ThemenBoxesTitle: this.$LanguageProvider.GetResource("ThemenBoxesTitle", "Caption", "Themenkacheln"),
                    SuchfeldTitleCards: this.$LanguageProvider.GetResource("SuchfeldTitleCard", "Caption", "SUCHFELDER"),
                    SuchfelderDesCards: this.$LanguageProvider.GetResource("SuchfelderDesCard", "Caption", "Die Themen sind in den nachfolgenden Suchfeldern organisiert. Wählen Sie Ihren Themenfeld-Einstieg und entdecken Sie die redaktionell ausgearbeiteten Themenkarten."),
                    NoResultCards: this.$LanguageProvider.GetResource("NoResultCards", "Caption", "Die Suche liefert keine Ergebnisse"),
                    ThemeTypesCards: this.$LanguageProvider.GetResource("ThemeTypesCards", "Caption", "THEMENTYPEN"),
                    SteepFactors: this.$LanguageProvider.GetResource("SteepFactors", "Caption", "STEEP-VL FAKTOREN"),
                    TrendCards: this.$LanguageProvider.GetResource("TrendCards", "Caption", "Trend"),
                    Searchfield: this.$LanguageProvider.GetResource("Searchfield", "Caption", "Suchfeld:"),
                    AllSearchfields: this.$LanguageProvider.GetResource("AllSearchfields", "Caption", "Alle Suchfelder"),
                    All: this.$LanguageProvider.GetResource("All", "Caption", "Alle"),
                    TrendDesCards: this.$LanguageProvider.GetResource("TrendDesCards", "Caption", " Ein Thema, für das im Zeitverlauf bereitsmehrere Belege existieren und das sich erkennbar in eine Richtung weiterentwickelt."),
                    SteepFactorsDes: this.$LanguageProvider.GetResource("SteepFactorsDesc", "Caption", "Neben der Einteilung nach Thementypen werden die Themen der Plattform den STEEP-VL-Faktoren zugeordnet. Die englische Abkürzung STEEP-VL steht für Social, Technological, Economical, Ecological, Political, Values und Legal. Es geht also darum, inwiefern das Thema soziale, technologische, ökonomische, ökologische, politische, ethische und rechtliche Auswirkungen hat.Die Analyse der STEEP - VL - Faktoren  ist eine in der Zukunftsforschung vielfach angewandte Methode zur Systematisierung möglicher Einflussfaktoren im Umfeld einer Organisation.Ziel ist der umfassende Überblick über diese Faktoren sowie die Einschätzung ihrer Relevanz und der gegenseitigen Wechselwirkungen."),
                    SignalCards: this.$LanguageProvider.GetResource("SignalCards", "Caption", "Signal"),
                    IdeaCards: this.$LanguageProvider.GetResource("IdeaCards", "Caption", "Idee"),
                    IdeaDesCards: this.$LanguageProvider.GetResource("IdeaDesCards", "Caption", "  Die Idee bezeichnet ein Konzept oder einen Ansatz, der bisher nur auf der konzeptionellen Ebene existiert - oft mit großen Disruptionspotenzialen einhergeht. Dabei ist die Eintrittswahrscheinlichkeit erstmals völlig unklar, da sich die Gesellschaft positionieren muss."),
                    SignalDesCards: this.$LanguageProvider.GetResource("SignalDesCards", "Caption", " Ein Signal ist ein erstes Anzeichen für etwas Neues, das für bestimmte Entwicklungen (Trends) als relevant eingestuft wird und potenziell einen bedeutenden Einfluss entwickeln könnte. Diese schwachen Signale haben oft besondere Aspekte, welche vom Blickwinkel des Scouts abhängen und nicht offensichtlich sind."),
                    WSDesCards: this.$LanguageProvider.GetResource("WSDesCards", "Caption", " Der White Spot bezeichnet den blinden Fleck. Diese charakterisiert Themen, die bisher nicht erkannt, übersehen oder unterschätzt wurden, obwohl Sie in Zukunft eine beachtliches Momentum erzeugen können. Sie sind schwer zu erkennen, da Sie teils außerhalb des Zuständigkeitsbereichs des BMAS liegen, bzw. erst durch die Bewertungen der BMAS Foresight Community erkennbar sind."),
                    GivenDesCards: this.$LanguageProvider.GetResource("GivenDesCards", "Caption", "Givens bezeichnet den Thementyp der gesetzten oder schwer veränderbaren Rahmenbedingungen, die eine Relevanz für aktuelle und zukünftige Entwicklungen aufweisen. Diese müssen in Möglichkeits- und Entscheidungsdenken zwingend berücksichtigt werden, da sie kaum veränderbar sind. Dies können zum Beispiel physikalische naturwissenschaftliche Gesetzmäßigkeiten, Gesetze & Richtlinien, Normen, Infrastrukturelle Gegebenheiten oder Korrelationen sein."),
                    ClusterTypeDesCards: this.$LanguageProvider.GetResource("ClusterTypeDesCards", "Caption", " Das Cluster bündelt die Beobachtungen des Redaktionsteams, welche bei der Identifikation Muster und Verbindungen erkannt haben. Wir sammeln und verbinden im Thementyp Cluster diese unterschiedlichsten Thementypen. Das Cluster als Sammlung stellt einen Zusammenhang dieser Themen dar, die wir dann gesondert beurteilen und betrachten können."),
                    ToThemenViewCards: this.$LanguageProvider.GetResource("ToThemenViewCards", "Caption", "Gehen Sie zur Listenansicht der Themen. Dort können Sie nach den unterschiedlichen Thementypen filtern. Hier gelangen Sie zur Themenübersicht: "),
                    ThemeTypesDesCards: this.$LanguageProvider.GetResource("ThemeTypesDesCards", "Caption", "Wir kategorisieren die Themen nach verschiedenen Thementypen. Je nach Charakter des Thementyps erfolgt eine unterschiedliche redaktionelle Ausar-beitung. Die Ausarbeitung von Signalen hilft Anderen, das Besondere zu er-kennen. Diese Thementypen wollen wir hier kurz vorstellen."),
                    SuggestHitTitle: this.$LanguageProvider.GetResource("SuggestHitTitle", "Caption", "SIE HABEN THEMENVORSCHLÄGE FÜR DAS BMAS FORESIGHT REDAKTIONSTEAM? DANN NICHTS WIE EINREICHEN!"),
                    SearchTextTitle: this.$LanguageProvider.GetResource("SearchTextTitle", "Caption", "Suchbegriff:"),
                    SuggestHitCaption: this.$LanguageProvider.GetResource("SuggestHitCaption", "Caption", " Teilen Sie uns mit, was Sie an diesem Thema spannend für die Arbeitswelt von morgen finden. Unsere Redaktion prüft und ergänzt jeden Vorschlag. Egal ob, der Wirtschaftsartikel aus Ihrer Morgenlektüre, Tweets spannende Kon-zeptansätze bzw. Ihr neuestes Lieblingspaper zu Workingout Loud – jeder In-put im Kontext der Arbeitswelt hilft uns dabei, gemeinsam die Aspekte der Ar-beitswelt von morgen zu entdecken und im BMAS zu interpretieren. Machen Sie mit!"),
                    SearchFieldText: this.$LanguageProvider.GetResource("SearchFieldText", "Caption", "Die Themen sind in den nachfolgenden Suchfeldern organisiert.Wählen Sie Ihren Themenfeld - Einstieg und entdecken Sie die redaktionell ausgearbeiteten Themenkarten:"),
                    SearchFieldSubhead: this.$LanguageProvider.GetResource("SearchFieldSubhead", "Caption", "Suchfelder "),

                },
                btn: {
                    FilterHintCards: this.$LanguageProvider.GetResource("FilterHintCards", "Caption", "Filter zurück setzen"),
                    DiceHintCards: this.$LanguageProvider.GetResource("DiceHintCards", "Caption", "Themen zufällig anordnen"),
                    ToThemeBtnCards: this.$LanguageProvider.GetResource("ToThemeBtnCards", "Caption", "zu der Themenübersicht"),
                    SuggestNewHitBtnCards: this.$LanguageProvider.GetResource("SuggestNewHitBtnCards", "Caption", "Themenvorschlag anlegen"),
                    ChooseSuchfeldBtnCards: this.$LanguageProvider.GetResource("ChooseSuchfeldBtnCards", "Caption", "Suchfeld auswählen"),
                },
                sortList: [{ SortId: 0, SortName: this.$LanguageProvider.GetResource("drpdownCardsAlphabetic", "Caption", "Alphabetisch") },
                { SortId: 1, SortName: this.$LanguageProvider.GetResource("drpdownCardsDateDesc", "Caption", "Datum absteigend") },
                { SortId: 2, SortName: this.$LanguageProvider.GetResource("drpdownCardsDateAsc", "Caption", "Datum aufsteigend") },
                { SortId: 3, SortName: this.$LanguageProvider.GetResource("drpdownCardsRandom", "Caption", "Zufall") },
                { SortId: 4, SortName: this.$LanguageProvider.GetResource("drpdownCardsRelevance", "Caption", "Relevanz") }
                ],
                selectionMode: true,
                pSuchfeldId: 0,
                pRouId: 0,
                onlySufs: false,
            };
        },
        computed: {
            suchfeldId: {
                get() {
                    return this.pSuchfeldId
                },
                set(newValue) {
                    const n = Number.parseInt(newValue, 10)
                    this.pSuchfeldId = n
                }
            },
            rouId: {
                get() {
                    return this.pRouId
                },
                set(newValue) {
                    const n = Number.parseInt(newValue, 10)
                    this.pRouId = n
                }
            },
            isLoading() {
                return this.$store.state.iconListStore.topicCardListIsLoading
            },
            wordSource() {
                var result = []

                if (this.topicCardList && this.topicCardList.length > 0) {

                    var merged = [].concat.apply([], this.topicCardList.map(m => {
                        return m.KeyWords;
                    }));

                    let counted = merged.reduce(function (
                        count,
                        currentValue
                    ) {
                        return (
                            count[currentValue] ? ++count[currentValue] : (count[currentValue] = 1),
                            count
                        );
                    },
                        {});
                    for (const [key, value] of Object.entries(counted)) {
                        result.push({ name: key, count: value })
                    }

                    //this.topicCardList.map(m => {
                    //    return { KeyWords: Array.from(m.KeyWords) };
                    //}).forEach(m => {
                    //    if (m.KeyWords) {
                    //        m.KeyWords.forEach(k => {
                    //            var kLower = k.toLowerCase()
                    //            var kw = result.find(r => r.name.toLowerCase() == kLower)

                    //            if (kw) {
                    //                kw.count++
                    //            }
                    //            else {
                    //                result.push({ name: k, count: 1 })
                    //            }
                    //        });
                    //    }
                    //});

                    var src = result.sort((a, b) => { return a.count < b.count ? 1 : -1 });
                    if (src.length > 20) {
                        src = src.slice(0, 20)
                    }
                    var res = src.map(k => { return { Name: k.name, Salience: k.count }; })
                }
                return res;

            },
            topicsInSuchfeld() {
                var list = this.$store.state.iconListStore.topicCardList
                var result = list.filter(m => (this.rouId == 0 || this.rouId == m.RouId) &&
                    (this.suchfeldId == 0 || (m.Suchfelder.includes(this.suchfeldId))))
                return result
            },
            topicCardList() {
                var list = this.$store.state.iconListStore.topicCardList
                var result = list.filter(m => (m.TtyId == this.currentTtyId || this.currentTtyId == 0) &&
                    (this.rouId == 0 || this.rouId == m.RouId) &&
                    (this.suchfeldId == 0 || (m.Suchfelder.includes(this.suchfeldId))))
                switch (this.selectedSortId) {
                    case 0:
                        result = result.sort((a, b) => (a.Title < b.Title ? -1 : 1))
                        break
                    case 1:
                        result = result.sort((a, b) => (a.CreatedOn > b.CreatedOn ? -1 : 1))
                        break
                    case 2:
                        result = result.sort((a, b) => (a.CreatedOn < b.CreatedOn ? -1 : 1))
                        break
                    case 3:
                        result = this.randomizeOrder(result)
                        break
                    case 4:
                        result = result.sort((a, b) => (a.Rank > b.Rank ? -1 : 1))
                        break
                }
                return result;
            },
            suchfeldInfo() {
                return this.$store.state.suchfeldStore.suchfeldInfo
            },
            suchfeldName() { 
                return this.suchfeldInfo && this.suchfeldInfo.LitId > 0 ? this.suchfeldInfo.LitName : this.tx.AllSearchfields
            },
            topicTypes() {
                var list = this.topicsInSuchfeld
                if (list) {
                    var result = [{ TtyId: 0, TtyName: this.tx.All, TtyIcon: 'fa-light fa-filter-circle-xmark', Count: list.length, Description: '' }]
                    list.forEach(m => {
                        var tty = result.find(e => e.TtyId == m.TtyId)
                        if (!tty) {
                            result.push({ TtyId: m.TtyId, TtyName: m.TtyName, TtyIcon: m.TtyIcon, Count: 1, Description: htmlToText(m.TtyDescription) })
                        }
                        else {
                            tty.Count++
                        }
                    });
                    return result;
                }
                return []
            },
            options() {
                return {
                    selectedSortId: this.selectedSortId,
                    currentTtyId: this.currentTtyId,
                    suchfeldId: this.suchfeldId,
                    rouId: this.rouId
                }
            }
        },
        props: {
            menuId: {
                type: [String],
                required: true,
                default: ""
            },
            roId: {
                type: [Number],
                required: false,

            },
            sufId: {
                type: [Number],
                required: false,

            },
            pgId: {
                type: [Number],
                required: true,

            },
            onlySearchfields: {
                type: [Boolean],
                required: false,

            },
            dashboard: {
                type: [Boolean],
                required: false,

            },
        },
        watch: {
            topicTypes(list) {

                if (this.currentTtyId == 0 && list.length > 0) {
                    this.currentTtyId = list[0].TtyId
                }
            },
            options(opt) {
                localStorage.setItem('topicCardOptions', JSON.stringify(opt));
            },
            wordSource() {
                //console.log("X", this.topicCardList, newVal, oldVal)
                if (this.topicCardList && this.topicCardList.length > 0) {
                    this.showLoading(false, "wordSource")
                }
            },
            topicsInSuchfeld() {
                //this.showLoading(true, "topicsInSuchfeld")
            },
            suchfeldId() {
                this.$store.dispatch("getSuchfeldInfo", { sufId: this.suchfeldId })
            }
        },
        created: function () {
        },
        mounted: function () {
            var params = {
                PgrId: this.pgId, RtyId: 1, imgSize: 280,
            };
            if (!this.pgId)
                params = {
                    PgrId: 1, RtyId: 1, imgSize: 280,
                };
            this.$store.dispatch("getPresentationList", params)
            this.onlySufs = this.onlySearchfields
            var sufId = this.sufId && this.sufId.length > 0 ? Number.parseInt(this.sufId, 10) : 0;
            try {
                var opt = sufId == 0 ? JSON.parse(localStorage.getItem('topicCardOptions')) : null;

                if (opt) {
                    this.selectedSortId = opt.selectedSortId
                    this.currentTtyId = opt.currentTtyId
                    this.rouId = opt.rouId
                    this.suchfeldId = opt.suchfeldId > 0 ? opt.suchfeldId : 0
                    sufId = opt.suchfeldId
                }
                else {
                    this.suchfeldId = sufId > 0 ? sufId : 0;
                    this.rouId = this.roId ? this.roId : 0;
                }
                this.selectionMode = sufId == -1
                if (this.selectionMode)
                    $('#qhpForm').hide()
            }
            catch {
                return
            }
        },

        methods: {
            toggleDefault() {
                this.defaultVisible = !this.defaultVisible;
            },

            openTopicKarten() {
                window.LoadPanel.Show()
                $("form").attr("action", window.location.pathname + "?action=OpenTopicOverviewVx").submit();
        
            },
            addNewTopic() {
                window.LoadPanel.Show()
                $("form").attr("action", window.location.pathname + "?action=CreateNewTopic").submit();
            },
            doRandomSort() {
                this.selectedSortId = -1
                localStorage.setItem('topicCardOrder', null)
                this.selectedSortId = 3;
            },
            showSuchfeldSelection() {
                $('#qhpForm').hide()
                this.selectionMode = true
            },
            showStartPage() {
                this.$emit("showSelection")
                this.selectionMode = true
            },

            openDetail(topicId) {
                window.LoadPanel.Show()
                var list = JSON.stringify(this.topicCardList.map(m => m.TopicId))
                var data = { action: "read", id: topicId, list: list, sf: this.suchfeldId }
                var url = window.location.pathname
                window.post(url, data)
            },
            async selectSuchfeld(data) {
                this.$emit("selected", { selected: false, litId: data.litId, rouId: data.rouId, suchfeldName: data.suchfeldName })
                window.LoadPanel.Show()
                if (this.suchfeldId != data.litId) {
                    this.showLoading(true, "selectSuchfeld")
                }
                await nextTick()
                setTimeout(() => {
                    this.rouId = data.rouId
                    this.currentTtyId = 0
                    $('#qhpForm').show()
                    this.suchfeldId = data.litId
                    this.selectionMode = false
                    this.searchText = ""
                    this.reload()
                    this.scrollToTop()

                }, 100)
            },
            searchClick() {
                this.tag = ""
                this.reload()
            },
            tagClicked(args) {
                this.tag = args.word.Name
                this.searchText = ""
                this.reload()
            },
            resetSearch() {
                this.tag = ""
                this.searchText = ""
                this.reload()
            },
            reload() {
                if (this.searchText != this.searchedText || this.tag != this.searchedTag) {
                    //this.showLoading(true,"reload")
                    window.LoadPanel.Show()
                    if (this.searchedText != "") {
                        this.selectedSortId = 4
                    }
                    const params = { PgrId: 1, RtyId: 1, imgSize: 280, Search: this.searchText, Tag: this.tag }
                    this.$store.dispatch("getPresentationList", params).then(() => {
                        this.searchedText = this.searchText
                        this.searchedTag = this.tag
                    })
                }
                else {
                    window.LoadPanel.Hide()
                }
            },
            scrollToTop() {
                window.scrollTo(0, 0);
            },
            showLoading(display, triggerName) {
                this.tagsLoaded = !display
                console.log("showLoading", triggerName, display)
                //var element = window.document.getElementById("divLoading")
                //element.style.display = display ? "block" : "none"
                this.$forceUpdate();
            },
            randomizeOrder(data) {
                if (data && data.length > 0) {
                    const eoTxt = localStorage.getItem('topicCardOrder');
                    var cardOrder = [];
                    try {
                        cardOrder = JSON.parse(eoTxt);
                        cardOrder = cardOrder ? cardOrder : [];
                    }
                    catch {
                        cardOrder = [];
                    }
                    data.map(m => {
                        const nr = cardOrder.find(s => s.TopicId == m.TopicId);
                        m.Rnd = nr ? nr.Rnd : Math.random();
                        return m;
                    })
                    var order = JSON.stringify(data.map(m => { return { TopicId: m.TopicId, Rnd: m.Rnd } }));
                    localStorage.setItem('topicCardOrder', order);
                    return data.sort((a, b) => {
                        if (a.Rnd == b.Rnd) {
                            return 0;
                        }
                        else if (a.Rnd < b.Rnd) {
                            return -1;
                        }
                        return 1;
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .vdSuchfelder {
        display: flex;
        flex-direction: column;
    }

    .tableTextWlc {
        color: var(--icon-table-text-color);
        padding-left: 10px;
        width: 400px;
        font-size: var(--icon-table-text-size);
        padding-top: 5px;
    }

    .tableIconTextTitle {
        font-weight: bold;
        color: #00a5c3;
        padding-left: 10px;
        width: 200px;
        font-size: 15px;
        padding-top: 10px;
    }

    .iconTable > i {
        margin-bottom: 12px;
        color: var(--topicCardview-icon-color);
        font-size: 60px;
        padding-left: 10px;
    }

    .fa-regular {
        color: #00a5c3;
    }

    td {
        padding-bottom: 20px;
        vertical-align: top;
    }

    .iconTable {
        width: 105px;
        padding-left: 30px;
    }

    .paragraph {
        padding-bottom: 80px;
    }

    .tsBtnDx {
        width: 130px;
        background-color: var(--m02-color-1);
        margin-bottom: 10px;
        margin-top: 20px;
        padding: 7px;
    }

    .tsBtnÜbersicht {
        width: 170px;
        background-color: var(--m02-color-1);
        margin-bottom: 20px;
        margin-top: 20px;
        padding: 7px;
    }

    .divÜbersicht {
        margin-top: 40px;
    }

    .tsAddNew {
        width: 178px;
        background-color: var(--m02-color-1);
        margin: 0px 0px 20px 0px;
        height: 36px;
        padding: 7px;
    }

        .tsAddNew:hover, .tsBtnDx:hover, .tsBtnÜbersicht:hover {
            background-color: var(--danger-hover-color);
            box-shadow: 0px 0px 5px 0px rgb(255 255 255 / 50%);
        }

    .head {
        padding-top: 20px;
    }

    .btnAll div {
        margin-right: 10px;
    }

    #QuickHelpBox .portlet-content {
        display: none;
    }

    .vdContents {
        display: contents;
    }

    .vdFilterControls {
        display: flex;
        gap: 5px;
    }

    .vdInnerBox {
        display: grid;
        grid-template-columns: repeat(auto-fit, 280px);
        grid-template-rows: repeat(400px);
        gap: 50px;
        width: 100%;
        max-width: 100%;
    }

    .vdFilter {
        margin: 0 0 10px;
    }

    body #SheetContentContainer .CpContent {
        padding: 0 10px 0 10px;
    }

    .vdBody {
        display: grid;
        grid-template-rows: auto;
        width: 100%;
        height: 100%;
        border: solid 1px #d8d4d4;
        padding: 10px;
        padding-bottom: 0px;
        align-content: start;
        border-radius: 3px;
    }

        .vdBody:hover {
            box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 10%);
        }

    .vdVideoPlayer {
        width: 100%;
        height: 100%;
    }

    .subhead {
        padding-bottom: 20px;
        font-size: var(--page-description-text-size);
        max-width: 700px;
    }

    .subHeadDes {
        color: var(--topicCardview-subhead-description-color);
        padding-bottom: 20px;
        font-size: var(--topicCardview-subhead-description-size);
        font-weight: bold;
        padding-bottom: 10px;
    }

    .vdId, .vdTitle {
        font-weight: bold;
        font-size: 12px;
        padding-top: 11px;
    }

    .vdAuthor, .vdLength {
        font-size: 11px;
    }

    @media only screen and (max-width:699px) {
        div#frmMain {
        }
    }

    @media only screen and (max-width:699px) {
    }

    .vdFooter {
        display: grid;
        grid-template-columns: auto;
    }

    .vdTitle {
        grid-row: 2;
        grid-column: 1;
        border-top: solid 1px #d8d4d4;
        margin-top: 10px;
    }

    .vdTfiName {
        grid-row: 1;
        grid-column: 1;
        font-size: 11px;
    }

    .vdRating {
        grid-row: 1 / 3;
        grid-column: 2;
        display: grid;
        grid-template-columns: auto auto;
        justify-self: end;
        align-self: end;
        width: 90px;
        color: gray;
    }

    .vdRat {
        display: grid;
        grid-template-columns: auto auto;
    }

    .vdIcon {
        font-size: 36px;
        cursor: pointer;
        color: var(--danger-hover-color);
        margin: 10px 10px 10px 0;
        vertical-align: middle;
    }

        .vdIcon:hover {
            color: var(--flag-color-4);
        }

    .vdAuthor, vdLength {
        grid-column: 1 / 2;
    }

    .vdAuthor {
        grid-row: 2;
        grid-column: 1;
    }

    .vdVote {
        color: var(--flag-color-4);
    }

    .vdLength {
        grid-row: 3;
        grid-column: 1;
    }

    .vdArticel .vdBody img {
        width: 280px;
        height: 280px;
        object-position: center;
        object-fit: contain;
        background: white;
        align-self: self-end;
    }

        .vdArticel .vdBody img:hover {
            filter: grayscale(100%);
        }

    .vdArticel:hover {
        cursor: pointer;
    }


    .vdFilterBox {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;
    }

    .vdFilterRight {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;
        gap: 15px;
    }

    .vdFilterCell .dx-item-content {
        display: flex;
        flex-direction: row;
        /* justify-content: center; */
        align-items: center;
        /* margin: 0; */
        /* padding: 0; */
    }

    .vdTtyName {
        display: inline-block;
    }

    .vdFilterBox {
        display: flex;
        gap: 10px;
        align-content: baseline;
        align-items: center;
    }

    .vdEmpty {
        display: flex;
        justify-content: center;
        padding-top: 50px;
        font-size: 25px;
    }

    .vdDice i {
        font-size: 37px;
        color: var(--danger-color);
        cursor: pointer;
    }

        .vdDice i:hover {
            color: var(--m01-color-1)
        }

    .vdFilterLeft {
        display: flex;
        flex-direction: row;
        gap: 40px;
        align-items: baseline;
    }

    .vdSuchfeld {
        font-size: var(--topicCardview-suchfeld-detail-size);
        color: var(--topicCardview-suchfeld-detail-color);
        font-weight: bold;
        padding-bottom: 6px;
        padding-top: 20px;
    }

    .footerParagraph {
        padding-top: 20px;
    }

    .dx-state-invisible {
        display: block !important;
    }

    .vdFilterCell .dx-item-content {
        display: flex;
    }

    .vdIcon .tooltiptext {
        visibility: hidden;
        width: 120px;
        color: black;
        background-color: var(--page-bg-color);
        font-family: var(--font-family);
        font-size: 12px;
        margin-left: 10px;
        /*text-align: center;*/
        border-radius: 6px;
        padding: 10px;
        /* Position the tooltip */
        position: absolute;
        box-shadow: 1px 2px 6px #888888;
        width: auto;
        max-width: 500px;
        z-index: 1;
        line-height: 1.3em;
    }

    .vdIconTag .tooltiptext {
        visibility: hidden;
        width: 120px;
        color: black;
        background-color: var(--page-bg-color);
        font-family: var(--font-family);
        font-size: 12px;
        margin-left: 69px;
        margin-top: -20px;
        /*text-align: center;*/
        border-radius: 6px;
        padding: 10px;
        /* Position the tooltip */
        position: absolute;
        box-shadow: 1px 2px 6px #888888;
        width: auto;
        max-width: 500px;
        z-index: 1;
        line-height: 1.3em;
    }

    .vdIcon:hover .tooltiptext {
        visibility: visible;
    }

    .vdIconTag:hover .tooltiptext {
        visibility: visible;
    }

    .dx-widget.dx-button.dx-button-mode-contained.dx-button-normal.dx-button-has-text.dx-button-has-icon {
        background-color: var(--danger-color);
    }

    .tsImg {
        font-size: 20px;
    }
</style>
